import React from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import moment from "moment";

import PopupCustomized from '../../../../../components/PopupCustomized';
//import TeamComparisonChart from '../../../../../components/v3/Graphs/SurveyActivity/TeamComparisonChart';
//import ProgressOverTimeChart from '../../../../../components/v3/Graphs/SurveyActivity/ProgressOverTimeChart';
import TicketCountProgressOverTimeContainer from '../../../../../components/v3/Graphs/ChartContainer/TicketCountProgressOverTimeContainer';

import HelpOutline from '@material-ui/icons/HelpOutline';

import { isDefined, getOnlyUnique, cloneArray } from '../../../../../utils';

class TeamsCompareAndOverTimeGraphs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mouseClickX: 100,
            mouseClickY: 100
        };

        //this.showTeamComparisonHelpPopup = this.showTeamComparisonHelpPopup.bind(this);
        //this.closeTeamComparisonHelpPopup = this.closeTeamComparisonHelpPopup.bind(this);
        this.showProgressOverTimeHelpPopup = this.showProgressOverTimeHelpPopup.bind(this);
        this.closeProgressOverTimeHelpPopup = this.closeProgressOverTimeHelpPopup.bind(this);

        /*        this.onSelectNewTimePeriodicity = this.onSelectNewTimePeriodicity.bind(this);*/
    }

    //showTeamComparisonHelpPopup(e) {
    //    this.setState({ showTeamComparisonHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    //}

    //closeTeamComparisonHelpPopup() {
    //    this.setState({ showTeamComparisonHelpPopup: false });
    //}

    showProgressOverTimeHelpPopup(e) {
        this.setState({ showProgressOverTimeHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeProgressOverTimeHelpPopup() {
        this.setState({ showProgressOverTimeHelpPopup: false });
    }

    //onSelectNewTimePeriodicity(selectedOption) {
    //    const
    //        {
    //            onSelectNewTimePeriodicity
    //        } = this.props;

    //    onSelectNewTimePeriodicity(selectedOption.id);
    //}

    render() {
        const
            {
                progressOverTimeStats,
                progressOverTimeStatsByTeam,
                userTeamsStats,
                selectedTeam,
            } = this.props;

        let progressOverTimeChartNode = (<div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
            <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
        </div>);
        if (isDefined(progressOverTimeStats) && Array.isArray(progressOverTimeStats)) {
            progressOverTimeChartNode = (<TicketCountProgressOverTimeContainer
                valueType="ticketCount"
                chartType="spline"
                ticketCountOverTimeStats={progressOverTimeStats}
                propId="TicketCountProgressOverTimeChart1" />);
        }

        //let teamComparisonChartNode = (<div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
        //    <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
        //</div>);
        //if (isDefined(progressOverTimeStatsByTeam) && Array.isArray(progressOverTimeStatsByTeam)) {
        //    let teamComparisonAll = undefined;
        //    if (isDefined(userTeamsStats) && isDefined(progressOverTimeStatsByTeam)
        //        && Array.isArray(progressOverTimeStatsByTeam)) {
        //        teamComparisonAll = [];
        //        if (progressOverTimeStatsByTeam.length > 0) {
        //            let progressOverTimeStatsCopyForTeams = cloneArray(progressOverTimeStatsByTeam);

        //            //Filter By Team
        //            if (isDefined(selectedTeam)) {
        //                progressOverTimeStatsCopyForTeams = progressOverTimeStatsCopyForTeams.filter(p =>
        //                    selectedTeam.teamId == p.teamId);
        //            }

        //            var uniqueTeamIds = progressOverTimeStatsCopyForTeams.map(p => p.teamId).filter(getOnlyUnique);
        //            if (progressOverTimeStatsCopyForTeams.length > 0) {

        //                uniqueTeamIds.map(teamId => {
        //                    const dataOfTheDay = progressOverTimeStatsCopyForTeams.filter(p => p.teamId === teamId);

        //                    const ticketCountTotal =
        //                        dataOfTheDay.map(i => i.ticketCount).reduce((a, b) => a + b);

        //                    const agentSurveyCountTotal =
        //                        dataOfTheDay.map(i => i.agentSurveyCount).reduce((a, b) => a + b);

        //                    const customerSurveyCountTotal =
        //                        dataOfTheDay.map(i => i.customerSurveyCount).reduce((a, b) => a + b);

        //                    let teamName = teamId;
        //                    const team = userTeamsStats.find(t => t.teamId === teamId);
        //                    if (isDefined(team)) {
        //                        teamName = team.name;
        //                    }

        //                    const datesAccumulatedData = {
        //                        teamId: teamId,
        //                        name: teamName,
        //                        ticketCount: ticketCountTotal,
        //                        agentSurveyCount: agentSurveyCountTotal,
        //                        customerSurveyCount: customerSurveyCountTotal,
        //                    };
        //                    teamComparisonAll.push(datesAccumulatedData)
        //                });
        //            }
        //        }
        //    }
        //    teamComparisonChartNode = (<TeamComparisonChart
        //        teamsInputStats={teamComparisonAll}
        //        propId="TeamComparison" />);
        //}

        //const teamCompHelp = "Team comparison shows your interaction volume, agent survey volume and customer response broken down by your teams.";
        const progressOverTimeHelp = "Progress over time graph shows your interaction volume, agent survey volume and customer response volume over time.";

        return (
            <Tabs defaultIndex={1}>
                <TabList>
                    {/*<Tab>*/}
                    {/*    <div className="flex-container-center description-title">*/}
                    {/*        <div>Team Comparison</div>*/}
                    {/*        <div className="flex-container-center" style={{ marginLeft: '5px' }}>*/}
                    {/*            <HelpOutline onClick={this.showTeamComparisonHelpPopup} />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    {*/}
                    {/*        this.state.showTeamComparisonHelpPopup &&*/}
                    {/*        <PopupCustomized*/}
                    {/*            x={this.state.mouseClickX}*/}
                    {/*            y={this.state.mouseClickY}*/}
                    {/*            Message={teamCompHelp}*/}
                    {/*            close={this.closeTeamComparisonHelpPopup} />*/}
                    {/*    }*/}
                    {/*</Tab>*/}
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>Progress Over Time</div>
                            <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                <HelpOutline onClick={this.showProgressOverTimeHelpPopup} />
                            </div>
                        </div>
                        {
                            this.state.showProgressOverTimeHelpPopup &&
                            <PopupCustomized
                                x={this.state.mouseClickX}
                                y={this.state.mouseClickY}
                                Message={progressOverTimeHelp}
                                close={this.closeProgressOverTimeHelpPopup} />
                        }
                    </Tab>
                </TabList>

                {/*<TabPanel style={{ height: '465px', position: 'relative', marginTop: '30px' }}>*/}
                {/*    <div className="graphs">*/}
                {/*        {teamComparisonChartNode}*/}
                {/*    </div>*/}
                {/*</TabPanel>*/}

                <TabPanel style={{ height: '465px', position: 'relative', marginTop: '30px' }}>
                    <div className="graphs">
                        {progressOverTimeChartNode}
                    </div>
                </TabPanel>

            </Tabs >);
    }
};

const select = state => ({});
export default connect(select)(TeamsCompareAndOverTimeGraphs);
